module.exports = "/images/anna.jpg?a6d7782c496c6db353248f71572d08a7";